<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isLoading"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >{{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="isLoading"
            size="mini"
            type="success"
            icon="el-icon-upload2"
            @click="handleSave"
          >{{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>
    <div v-loading="isLoading">
      <el-form
        ref="form"
        :disabled="isLoading"
        :model="form"
        :rules="formRules"
        class="round-border-form"
        label-position="top"
        label-width="200"
      >
        <div class="form-group" style="width: 500px">
          <el-form-item
            label="Country"
            prop="country"
          >
            <el-select
              :placeholder="$t('placeholder.select')"
              :disabled="isEditMode"
              v-model="form.country"
              @change="handleCountryChange"
            >
              <el-option
                v-for="item in countryList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
                
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Locale"
            prop="locale"
          >
            <el-select
              :placeholder="$t('placeholder.select')"
              :disabled="isEditMode"
              v-model="form.locale"
            >
              <el-option
                v-for="item in localeOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </div>

        <el-form-item
          label="Title"
          prop="title"
        >
          <el-input
            v-model="form.title"
            clearable
          />
        </el-form-item>
        
        <el-form-item
          label="Button Text"
          prop="button_text"
        >
          <el-input
            v-model="form.button_text"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Link"
          prop="link"
        >
          <el-input
            v-model="form.link"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Title Text Color"
          prop="title_text_color"
        >
          <el-input
            v-model="form.title_text_color"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Background Color"
          prop="background_color"
        >
          <el-input
            v-model="form.background_color"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Button Text Color"
          prop="button_text_color"
        >
          <el-input
            v-model="form.button_text_color"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Button Background Color"
          prop="button_background_color"
        >
          <el-input
            v-model="form.button_background_color"
            clearable
          />
        </el-form-item>
        
        <el-form-item
          label="Date Range"
          prop="dateRange"
        >
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="Start date"
            end-placeholder="End date">
          </el-date-picker>
        </el-form-item>
      
      </el-form>
    </div>
  </sticky-header-layout>
</template>

<script>
import { reactive } from '@vue/composition-api'
import HomeConfigsAPI from '../../api/home-configs'
import MarketplaceService from '../../api/marketplace'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'
import { i18n } from '@/lang'
import { formatDatetime } from '../../utils/datetime'

export default {
  name: 'HelloBarDetail',
  components: {
    ListPageHeader,
  },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    const fromRule = reactive({
      country: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      locale: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      title: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      button_text: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      link: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      title_text_color: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      background_color: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      button_text_color: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      button_background_color: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      start_at: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      end_at: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
    })
    
    return {
      dateRange: null,
      countryList: [],
      countryLocaleMap: {},
      isLoading: true,
      form: {
        country: '',
        locale: '',
        title: '',
        button_text: '',
        link: '',
        title_text_color: '',
        background_color: '',
        button_text_color: '',
        button_background_color: '',
        start_at: '',
        end_at: '',
        // dateRange: '',
      },
      formRules: fromRule
    }
  },
  computed: {
    isEditMode() {
      return !!this.id
    },
    canSave() {
      return !this.loading
    },
    localeOptions: function(event) {
      return this.countryLocaleMap[this.form.country] ? this.countryLocaleMap[this.form.country] : []
    }
  },
  mounted() {
    if (this.isEditMode) {
      this.getDetail(this.id)
    } else {
      this.getCountryAndLocaleList()
    }
  },
  methods: {
    formatDatetimeToUTC(date) {
      return formatDatetime({ date: date, timezoneOffset: -8})
    },
    async getDetail() {
      this.isLoading = true
      try {
        const response = await HomeConfigsAPI.getHelloBarDetail(this.id)
        // console.log(response)
        const { data } = response
        this.form = data
        if (this.form.start_at && this.form.end_at) {
          this.dateRange = [formatDatetime({date: this.form.start_at}), formatDatetime({date: this.form.end_at})]
        }
        // this.form.dateRange = [formatDatetime({date: data.start_at}), formatDatetime({date: data.end_at})]
        
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async handleSave() {
      try {
        if (!this.dateRange) {
          this.form.start_at = ''
          this.form.end_at = ''
        } else {
          this.form.start_at = this.formatDatetimeToUTC(this.dateRange[0])
          this.form.end_at = this.formatDatetimeToUTC(this.dateRange[1])
        }

        await this.$refs.form.validate()
        
        if (this.isEditMode) {
          this.editHelloBar(this.id, this.form)
        } else {
          this.createHelloBar(this.form)
        }
        // console.log(this.form)
      } catch (error) {
        this.$alert('Please fill in all the required information.', 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
    handleCancel() {
      this.$router.push({ path: `/home-configs/hello-bars` })
    },
    async getCountryAndLocaleList() {
      this.isLoading = true
      const res = await MarketplaceService.getCountryList()
      var data = [...res.data]
      var countryLocaleMap = {}
      var countryList = []
      for (const item of data){
        countryLocaleMap[item.code.toLowerCase()] = item.available_locales.map(locale => {
          locale = locale.toLowerCase()
          switch (locale) {
            case 'zh-hk':
            case 'zh-tw':
              return 'zh'
              break;
            case 'zh-cn':
              return 'cn'
              break;
            case 'th-th':
              return 'th'
              break;
          }
          return locale
        })
        countryList.push({'code': item.code.toLowerCase(), 'name': item.name})
      }
  
      this.countryList = countryList
      this.countryLocaleMap = countryLocaleMap
      this.isLoading = false
    },
    handleCountryChange(country) {
      this.form.locale = ''
    },
    async createHelloBar(form) {
      this.isLoading = true
      try {
        const result = await HomeConfigsAPI.createHelloBar(form)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async editHelloBar(id, form) {
      this.isLoading = true
      try {
        const result = await HomeConfigsAPI.updateHelloBar(id, form)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    handleSaveSuccess() {
      this.isLoading = false
      this.$router.push({ path: `/home-configs/hello-bars` })
    },
    handleSaveFail(error) {
      this.isLoading = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";
@import "~@/assets/styles/table.scss";
</style>

